import HTML from './html'

/**
 * Constructs nice none-SELECT-driven drop-down solution
 * @param {{
 *    buttonText: string,
 *    list: [{
 *      attributes: object,
 *      classes: string,
 *      content: string,
 *      events: [{
 *        event: string,
 *        callback: function}]
 *      }]
 *    }} options
 * @returns {Node}
 */
export function ultraSelect(options) {
    let closeSelect,
        openSelect,
        toggleSelect,
        button,
        menu,
        opts = options.list.map(opt => {
            return HTML('li')
                .attr(opt.attributes || {})
                .classes(opt.classes ? 'u-select__menu__item ' + opt.classes : 'u-select__menu__item')
                .append(
                    HTML('button')
                    // .attr({href: "#"})
                        .content(opt.content)
                        .classes('u-select__menu__item__link')
                        .defineListeners(opt.events || [])
                        .on('click', (event, element) => {
                            closeSelect()
                            if (typeof opt.onClick === 'function') {
                                opt.onClick(event, element, button, menu)
                            }
                        })
                        .render(),
                )
                .render()
        })

    button = HTML('button')
    // .attr({href: "#"})
        .classes('u-select__button')
        .append(HTML('span').classes('u-select__button__name').content(options.buttonText))
        .on('click', event => {
            event.preventDefault()
            toggleSelect()
        })
        .append(
            HTML('i')
                .attr({
                    class: 'icon icon-arrow-down',
                    'aria-hidden': 'true',
                }).render(),
        )
        .render()

    menu = HTML('ul')
        .classes('u-select__menu')
        .append(opts)
        .render()

    document.addEventListener('click', event => {
        if (event.target !== button && menu !== event.target) {
            closeSelect()
        }
    })

    closeSelect = function() {
        $(menu).removeClass('visible')
        $(button).removeClass('active')
    }
    openSelect = function() {
        $(menu).addClass('visible')
        $(button).addClass('active')
    }
    toggleSelect = function() {
        $(menu).hasClass('visible') ? closeSelect() : openSelect()
    }

    return HTML('figure')
        .classes('u-select')
        .append(button, menu)
        .render();
}
